import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { SessionStorageService } from './session-storage.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class ImageService {
  private $api: string = '';

  private $session = new SessionStorageService();

  private $token: string = '';

  constructor($ajax: AjaxService) {
    this.$api = $ajax.getAPIDomain();
    this.$token = 'token=' + this.$session.getAuthorizationToken();
  }

  /**
   * 운동 이미지
   */
  exerciseImage(exerciseNumber: number): string {
    return this.$api + `ex-image/${exerciseNumber}?${this.$token}`;
  }

  /**
   * 운동 브레인볼 이미지
   */
  exerciseBrainballImage(exerciseNumber: number): string {
    return this.$api + `ex-brain-ball/${exerciseNumber}?${this.$token}`;
  }

  /**
   * 운동 별 뇌 이미지
   */
  exerciseBrainImage(exerciseNumber: number): string {
    return this.$api + `brain-image/${exerciseNumber}?${this.$token}`;
  }
}
